<template>
  <van-dialog
    v-model="dialogVisible"
    :show-confirm-button="false"
    width="280px"
    :close-on-click-overlay="true"
    class="notice-dialog"
  >
    <div class="notice-container">
      <img
        class="notice-logo"
        src="@/assets/images/notice-dialog-icon.png"
        alt=""
      />
      <h1>{{ noticeInfo.title }}</h1>
      <p class="notice-content">
        {{ noticeInfo.content }}
      </p>

      <div class="confirm-btn" @click="confirm">我知道了</div>
    </div>
  </van-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    noticeInfo: {
        type: Object,
        default: () => {}
    }
  },
  data() {
    return {
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    },
  },
  mounted() {
  },
  methods: {
    
    confirm() {
        this.dialogVisible = false
        if(this.noticeInfo.jump == 1) {
            this.$router.push({ path: '/gameCircle' })
        }
    }
  },
};
</script>

<style lang="scss" scoped>
.notice-dialog,
.van-dialog__content {
  overflow: visible; /* 允许内容超出 */
}
.notice-container {
  width: 560px;
  //   height: 217px;
  background: linear-gradient(180deg, #ffddce 0%, #ffffff 30%);
  border-radius: 20px;
  text-align: center;
  padding: 0 65px;
  padding-bottom: 30px;

  .notice-logo {
    width: 198px;
    height: 198px;
    margin-top: -100px;
  }
  h1 {
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 32px;
    color: #3b424c;
    margin: 15px 0 44px 0;
    width: 430px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .notice-content {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #8f8f8f;
    line-height: 36px;
    margin-bottom: 60px;
    text-align: left;
  }

  .confirm-btn {
    width: 430px;
    height: 77px;
    background: url("~@/assets/images/notice-dialog-btn-bg.png");
    background-size: 100% 100%;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #ff7a3e;
    line-height: 77px;
    text-align: center;
  }
}
.van-dialog {
  background: transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/NoticeDialog.vue